import { render } from "./chainSelectChevron.vue?vue&type=template&id=20717b98&scoped=true&lang=pug"
const script = {}

import "./chainSelectChevron.vue?vue&type=style&index=0&id=20717b98&scoped=true&lang=css"
import "./chainSelectChevron.vue?vue&type=style&index=1&id=20717b98&lang=css"

import exportComponent from "/Users/liu/Downloads/cross-bridge v0.1.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20717b98"]])

export default __exports__